module.exports = __webpack_public_path__ + "static/booth-2f2bbf05e9e3ad173dfa639f37a5f46a.jpg";